<template>
     <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Purchasing Summary Report</h4>
                <p class="text-subtitle-1">Summary of items purchased</p>
            </v-col>
        </v-row>
    <v-divider></v-divider>
    <v-form ref="form">
        <v-row class="mt-1">
            <v-col>
                <DatePicker
                    label="From"
                    outlined
                    v-model="form.from"
                    dense
                    hide-details
                />
            </v-col>
            <v-col>
                <DatePicker
                    label="To"
                    outlined
                    v-model="form.to"
                    dense
                    hide-details/>
            </v-col>
            <v-col>
                <v-btn class="primary" block :loading="loading" @click="onClicked">
                    <v-icon left>mdi-magnify</v-icon>
                    search
                </v-btn>
            </v-col>
             <!-- <v-col>
                <v-btn color="scoundary" @click="handlePrint">
                    <v-icon left>mdi-printer</v-icon>
                    print
                </v-btn>
            </v-col> -->
        </v-row>
    </v-form>
     <v-row no-gutters class="mt-8 ml-2 mr-10">
            <v-col>
                <v-progress-linear indeterminate v-if="loading" />
                 <v-treeview
                    dense
                    :items="summary"
                    hoverable
                    activatable
                 >
                    <template v-slot:append="{ item }">
                        <span >{{ formatMoney(item.value," ",2) }}</span>
                    </template>
                 </v-treeview>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment';
import { formatMoney, formatNumber } from 'accounting';
import { getPurchaseSummary, printPuchaseSummary } from '../../services/purchase/reports';
import DatePicker from './../../components/common/DatePicker.vue';
import itemService from './../../services/stock/item';
import { isRequired } from './../../utils/validations';

export default {
    components: {
        DatePicker
    },
    data() {
        return {
            items: [
                {
                    id: null,
                    display_name :"ALL",
                }
            ],
            summary: [],
            loading: false,
            itemsLoading: false,
            form: {
                item_id : null,
                from: moment().format("YYYY-MM-DD"),
                to : moment().format("YYYY-MM-DD")
            }
        }
    },
    methods: {
        formatNumber,
        isRequired,
        formatMoney(n, currency) {
            return formatMoney(n, {
                symbol: currency,
                precision: 2,
                thousand: ",",
                format: {
                    pos : "%s %v",
                    neg : "%s (%v)",
                    zero: "--"
                }
            });
        },
        async onClicked() {
            try {
                this.loading = true;
                this.summary = [];
                let res = await getPurchaseSummary(this.form);
                this.summary = res.data;
            } catch(error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        searchItems(query) {
            this.itemsLoading = true;
            itemService.search(query).then(response => {
                this.items = Array.from(new Set([...this.items, ...response.data]));
            }).finally(() => {
                this.itemsLoading = false;
            })
        },
        handlePrint() {
            printPuchaseSummary(this.form)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar = { value: true, color: "error", text: message }
                });
        },
    }
}
</script>

<style>

</style>